import { StageGroup, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { stageGroupClient, StageGroupPathParameters, StageGroupQueryParameters } from './StageGroupClient';

const factory = createStudyEntityHookFactory<StageGroup, StageGroupPathParameters & StageGroupQueryParameters>(
    StudyEntityType.StageGroup
);

export const useStageGroups = factory.list(stageGroupClient.list);
